// DEPENDENCIES
import React from 'react';
import PropTypes from 'prop-types';

const ContentBlock = (props) => {

    const columnSizes = {
        12: "col-12 col-lg-12",
        11: "col-12 col-lg-11",
        10: "col-12 col-lg-10",
        9: "col-12 col-lg-9",
        8: "col-12 col-lg-8",
        7: "col-12 col-lg-7",
        6: "col-12 col-lg-6",
        5: "col-12 col-lg-5",
        4: "col-12 col-lg-4",
        3: "col-12 col-lg-3",
        2: "col-12 col-lg-2",
    }

    return (
        <div
            className={`${props.className ? props.className : ""} ${props.cols ? columnSizes[props.cols] : "col-12 col-lg-12"}`}
            style={props.columnStyle}
        >
            {props.children}
        </div>
    );
}

ContentBlock.propTypes = {
    // MAIN PROPS
    cols: PropTypes.number,
    className: PropTypes.string,
    columnStyle: PropTypes.object,
}

export default ContentBlock;
